// export const   serverUrl = "http://localhost:8081/";
// export const eventImagesUrl_OLD = "http://localhost:8081/eventimages/";

// export const serverUrl = "http://localhost:8085/";
// export const eventImagesUrl = "http://localhost:8085/eventimages/";
// export const currentUrl = "http://localhost:8080/";

export const serverUrl = "https://api.barhopp.live";
export const eventImagesUrl = "https://api.barhopp.live/eventimages/";
export const currentUrl = "https://barhopp.live";



// WEBPACK FOOTER //
// ./src/business/constants.js